import React from "react";

const Footer = () => {
  return (
    <footer className="w-full bg-white dark:bg-slate-900/60 border-t border-slate-200 dark:border-slate-700 mt-10">
      <div className="container mx-auto px-6 py-8 text-center">

        <p className="text-sm text-slate-700 dark:text-slate-300">
          <strong>Email:</strong>{" "}
          <a
            className="text-primary"
            href="mailto:admin@professionalsupplies.in"
          >
            admin@professionalsupplies.in
          </a>
        </p>

        <p className="text-sm text-slate-700 dark:text-slate-300 mt-2">
          <strong>Phone:</strong>{" "}
          <a className="text-primary" href="tel:+919969556677">
            +91 99695 56677
          </a>{" "}
          |{" "}
          <a className="text-primary" href="tel:+919969889900">
            +91 99698 89900
          </a>
        </p>

        <p className="text-xs text-slate-500 dark:text-slate-400 mt-4">
          Developed by{" "}
          <a
            href="https://arvitech.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            ARVI Technologies And Consultation
          </a>
        </p>

      </div>
    </footer>
  );
};

export default Footer;
